var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"border border-b-0 border-t border-x-0 text-gray-700 select-none relative px-4",attrs:{"role":"option"}},[(_vm.$slots.default)?_c('span',{staticClass:"font-bold block truncate pt-2"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }